<template>
  <form-field title="薪资/结算" is-require is-link @click="onClick">
    <div v-if="!display" class="placeholder">请选择薪资待遇</div>
    <div v-else>{{ display }}</div>
    <van-popup v-model="isShow" round class="salary-popup" get-container="#app" position="bottom" close-on-popstate safe-area-inset-bottom style="height: 60vh" @open="onOpen">
      <div class="nav-bar">
        <div class="nav-bar-left" @click="onBack">取消</div>
        <div class="nav-bar-title">薪资待遇</div>
        <div class="nav-bar-right" @click="onSave">确定</div>
      </div>
      <div id="content" class="content">
        <div class="controls">
          <form-input v-model="salaryForm.salary" title="薪资标准" is-require placeholder="请输入薪资标准" only-number type="number" pattern="[0-9]*">
            <div slot="append-icon" class="select-warp">
              <div class="unit-content" @click="handleClickSalaryUnit">
                <div class="unit-text">{{ salaryUnitOptions[defaultIndex].name }}</div>
                <base-icon class="down-icon" name="salary_arrow_down"></base-icon>
              </div>
              <van-popup v-model="isSalaryUnitShow" get-container="body" position="bottom" close-on-popstate safe-area-inset-bottom>
                <van-picker
                  v-if="isSalaryUnitShow"
                  show-toolbar
                  value-key="name"
                  title="选择薪资单位"
                  :default-index="defaultIndex"
                  :columns="salaryUnitOptions"
                  @confirm="onConfirmSalaryUnit"
                  @cancel="onCancelSalaryUnit"
                />
              </van-popup>
            </div>
          </form-input>
          <form-select v-model="salaryForm.salary_model" title="结算方式" is-require :options="salaryModelOptions"></form-select>
        </div>
      </div>
    </van-popup>
  </form-field>
</template>

<script>
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Validator from '@/utils/validator';
import { isDef } from '@/utils/common';
export default {
  name: 'FormSalary',
  props: {
    form: Object,
  },
  data() {
    return {
      isShow: false,
      salaryForm: {
        salary_unit: 1,
      },
      display: '',
      isSalaryUnitShow: false,
      displaySalaryUnit: '元/小时', // 默认
    };
  },
  computed: {
    ...mapGetters(['webConfig']),
    salaryUnitOptions() {
      return [
        {
          id: 1,
          name: '元/小时',
        },
        {
          id: 2,
          name: '元/天',
        },
        {
          id: 3,
          name: '元/次',
        },
        {
          id: 4,
          name: '元/月',
        },
      ];
    },
    salaryModelOptions() {
      return [
        { id: 'day', name: '日结' },
        { id: 'week', name: '周结' },
        { id: 'month', name: '月结' },
        { id: 'endAll', name: '完工结算' },
      ];
    },
    defaultIndex() {
      if (isDef(this.salaryForm.salary_unit)) {
        const index = this.salaryUnitOptions.findIndex(item => item.id === this.salaryForm.salary_unit);
        return index > -1 ? index : 0;
      } else {
        return 0;
      }
    },
  },
  watch: {
    form: {
      handler(val) {
        this.salaryForm = cloneDeep(val);
        if (this.salaryForm.work_type === 2) {
          this.$set(this.salaryForm, 'salary', this.salaryForm.salary_low);
        }
        this.getDisplay();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getContainer() {
      return document.querySelector('#content');
    },
    onClick() {
      this.isShow = true;
    },
    onBack() {
      this.isShow = false;
    },
    onOpen() {
      this.salaryForm = cloneDeep(this.form);
      if (this.salaryForm.work_type === 2) {
        this.$set(this.salaryForm, 'salary', this.salaryForm.salary_low);
        if (!this.salaryForm.salary_unit) {
          this.$set(this.salaryForm, 'salary_unit', 1);
        }
      }
    },
    onSave() {
      const msg = this.getErrorMsg(this.salaryForm);
      if (msg) {
        return this.$toast({ message: msg, getContainer: '#content' });
      }
      let params = JSON.parse(JSON.stringify(this.salaryForm, ['salary_face', 'salary_model', 'salary_low', 'salary_high', 'salary', 'salary_unit']));
      this.$emit('change', params);
      this.isShow = false;
    },
    getDisplay() {
      const obj = {
        day: '日结',
        week: '周结',
        month: '月结',
        endAll: '完工结算',
      };
      const salaryUnitObj = {
        1: '元/小时',
        2: '元/天',
        3: '元/次',
        4: '元/月',
      };
      if (this.salaryForm.salary && this.salaryForm.salary_model) {
        this.display = `${this.salaryForm.salary}${salaryUnitObj[this.salaryForm.salary_unit]} · ${obj[this.salaryForm.salary_model]}`;
      } else {
        this.display = '';
      }
    },
    /**
     * 校验表单获取报错信息
     * @param {Object} 表单数据
     * @return {String} 错误信息
     */
    getErrorMsg(form) {
      const validation = new Validator();
      validation.add(form.salary, [{ strategy: 'isEmpty', errorMsg: '请输入薪资标准' }]);
      validation.add(form.salary_model, [{ strategy: 'isEmpty', errorMsg: '请选择结算方式' }]);
      let errorMsg = validation.start();
      if (!errorMsg) {
        if (form.work_type === 1) {
          // 全职
          if (form.salary_face === 0) {
            // 不是面议
            if (this.webConfig.minimum_wage > 0 && form.salary_low * 1 < this.webConfig.minimum_wage) {
              errorMsg = '最低月薪不能小于' + this.webConfig.minimum_wage;
            }
            if (this.webConfig.max_wage > 0 && form.salary_high * 1 > this.webConfig.max_wage) {
              errorMsg = '最高月薪不能大于' + this.webConfig.max_wage;
            }
            if (form.salary_low * 1 > form.salary_high * 1) {
              errorMsg = '最高月薪不能小于最低月薪';
            }
          }
        } else if (form.work_type === 2) {
          // 兼职
          if (form.salary * 1 < 10) {
            errorMsg = '最低日薪不能小于10';
          }
          if (form.salary * 1 > 1000) {
            errorMsg = '最高日薪不能大于1000';
          }
        }
      }

      return errorMsg;
    },
    handleClickSalaryUnit() {
      this.isSalaryUnitShow = true;
    },
    onCancelSalaryUnit() {
      this.isSalaryUnitShow = false;
    },
    onConfirmSalaryUnit(value) {
      if (isDef(value)) {
        const selectItem = this.salaryUnitOptions.find(item => item.id === value.id);
        this.displaySalaryUnit = selectItem ? selectItem.name : '';
      }
      this.$set(this.salaryForm, 'salary_unit', value.id);
      this.isSalaryUnitShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.placeholder {
  font-size: 32px;
  color: #bbb;
}
.select-warp {
  .unit-content {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    &:before {
      content: '';
      display: block;
      width: 1px;
      height: 50px;
      background-color: #dcdfe6;
      position: absolute;
      left: -40px;
      top: 50%;
      transform: translateY(-50%);
    }
    .unit-text {
      color: #666;
    }
    .down-icon {
      width: 36px;
      height: 36px;
      margin-left: 5px;
    }
  }
}
.salary-popup {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 80%;
  overflow: hidden;
  .nav-bar {
    position: relative;
    height: 100px;
    background-color: #fff;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #edeef2;
    .nav-bar-left,
    .nav-bar-right {
      position: absolute;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      padding: 0 32px;
      font-size: 28px;
    }
    .nav-bar-left {
      left: 0;
      color: #999;
    }
    .nav-bar-right {
      right: 0;
      color: #e84c3d;
    }
    .nav-bar-title {
      max-width: 60%;
      margin: 0 auto;
      color: #333;
      font-weight: 500;
      font-size: 36px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .content {
    padding: 0 40px 40px;
    flex: 1;
    overflow-y: scroll;
    /deep/ .field {
      padding: 40px 0;
      .field__arrow {
        right: 0;
      }
      &:after {
        left: 0;
        right: 0;
      }
    }
  }

  .form-cell {
    border-bottom: 1px solid #edeef2;
    padding: 44px 0;
    display: flex;
    align-items: center;
    font-size: 32px;
    &_access {
      .form-cell__ft {
        position: relative;
        padding-right: 48px;
        .icon {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 36px;
          height: 36px;
          padding: 6px;
          margin-left: 16px;
        }
      }
    }
    &__bd {
      flex: 1;
      color: #333;
      white-space: nowrap;
    }
    &__ft {
      color: #666;
      padding-left: 20px;
    }
  }
}
</style>
